// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoPost_wrapper__J0IqO","more":"VideoPost_more__d0UPZ","shadow":"VideoPost_shadow__LTDeJ","content":"VideoPost_content__1r6lS"};